module.exports = __webpack_public_path__ + "img/notebook.c4120c5a.png";